import React from 'react';
var useRowsKeyControls = function (rowsData, uxState, onUxChange) {
    return React.useCallback(function (e) {
        var _a, _b;
        var selectedRowId = uxState.selectedRow;
        if (!selectedRowId)
            return;
        var selectedRowIdx = rowsData.findIndex(function (row) { return row.id === selectedRowId; });
        var previousRowId = (_a = rowsData[selectedRowIdx - 1]) === null || _a === void 0 ? void 0 : _a.id;
        var nextRowId = (_b = rowsData[selectedRowIdx + 1]) === null || _b === void 0 ? void 0 : _b.id;
        var isFirst = selectedRowIdx === 0;
        var isLast = selectedRowIdx === rowsData.length - 1;
        if (e.key === 'ArrowUp' && !isFirst)
            onUxChange === null || onUxChange === void 0 ? void 0 : onUxChange('selectedRow', previousRowId);
        if (e.key === 'ArrowDown' && !isLast)
            onUxChange === null || onUxChange === void 0 ? void 0 : onUxChange('selectedRow', nextRowId);
        if (e.key === 'Escape')
            onUxChange === null || onUxChange === void 0 ? void 0 : onUxChange('selectedRow', null);
    }, [uxState, rowsData, onUxChange]);
};
export default useRowsKeyControls;
